/**
 * @author Ahmed Serag
 * @copyright Copyright 2020 by Radivision Inc., CA, USA. All Rights Reserved.
 * @Date: 2018-09-11
 * @description Implementation of company details react component
 * @filename company-details.tsx
 */

import { Entity as GraphQlEntity } from "@radivision/graphql/lib/ts/graphql/entity";
import { SocialMediaCredential } from "@radivision/graphql/lib/ts/graphql/social-media-credential";
import React from "react";
import { RelayProps } from "../../../relay/relay-props";
import { DetailsTab } from "../profile-details-tab/details-tab";
import { ENVIRONMENT } from "../../../relay/relay-environment";
import { AddPortfolioItemModal } from "./manage-portfolio-modal";

/**
 * The props of the CompanyDetails component.
 *
 * @interface
 */
export interface CompanyDetailsProps extends RelayProps {
  list?: GraphQlEntity;
  updateContext: Function;
  owner: boolean;
}

export class CompanyDetails extends React.Component<CompanyDetailsProps> {
  render(): React.ReactNode {
    const { list: entity, owner, updateContext } = this.props;
    return (
      <div className="profile-details">
        <DetailsTab
          relay={this.props.relay}
          entity={entity}
          environment={ENVIRONMENT}
          isCompany={true}
          isPerson={false}
          isSpectator={false}
          isOwner={owner}
          updateUser={updateContext}
        />
        <AddPortfolioItemModal />
      </div>
    );
  }
}
